import React from "react";
import { styles } from "../styles/theme";

function Box({ label, value }) {
  return (
    <div style={styles.box}>
      <div style={styles.boxLabel}>{label}</div>
      <div style={styles.boxValue}>{value}</div>
    </div>
  );
}

export default Box;
